import { useCallback, useState } from 'react'

export const useSocialState = (setStatusMsg) => {
  const [remotePlayers, setRemotePlayers] = useState({})
  const [chatMessages, setChatMessages] = useState([])

  const updateRemotePlayer = useCallback((id, data) => {
    setRemotePlayers((prev) => ({ ...prev, [id]: { ...prev[id], ...data } }))
  }, [])

  const removeRemotePlayer = useCallback((id) => {
    setRemotePlayers((prev) => {
      const next = { ...prev }
      delete next[id]
      return next
    })
  }, [])

  const addChatMessage = useCallback((msg) => {
    setChatMessages((prev) => [...prev.slice(-99), msg])
    setStatusMsg(`${msg.username}: ${msg.message}`)
  }, [setStatusMsg])

  return { remotePlayers, chatMessages, updateRemotePlayer, removeRemotePlayer, addChatMessage }
}
